import Cookie from 'tiny-cookie';
import has from 'lodash/has';
// import moment from 'moment';
// import each from 'lodash/each';
// import isObject from 'lodash/isObject';
// import isString from 'lodash/isString';
// import unescape from 'lodash/unescape';
// import find from 'lodash/find';
// import clone from 'lodash/clone';
// import isEmpty from 'lodash/isEmpty';

export default class Auth {

        static getAuthData(state) {
                let authToken = window.persistStore.getItem('auth_token') || Cookie.get('auth_token');
                let userId = window.persistStore.getItem('user_id') || Cookie.get('user_id');

                if(!authToken && has(state, 'auth_token') && state.auth_token) authToken = state.auth_token;
                if(!userId && has(state, 'user_id') && state.user_id) userId = state.user_id;

                const authData = { authToken, userId };

                return authData;
        }

        static getAuthURL(url, state) {

                const { authToken, userId } = Auth.getAuthData(state);

                if (authToken && userId) {
                        url = `${url}&user_id=${userId}&user_auth_token=${authToken}`;
                }

                return url;
        }
}


// WEBPACK FOOTER //
// ./src/app/lib/Auth.js